<template>
    <div class="json-editor-wrapper jse-theme-dark" :class="validateError != '' ? 'box-border-color' : ''" :style="{ height: height }">
        <json-editor-vue
            v-model="internalValue"
            class="jse-theme-dark json-editor-inner"
            :mode="mode"
            :stringified="stringified"
            :read-only="readOnly"
            :navigation-bar="navigationBar"
            :status-bar="statusBar"
            :main-menu-bar="mainMenuBar"
            :indentation="2"
            @input="handleInput"
        />
        <span class="invalid-feedback-custom" v-show="validateError" v-html="validateError" />
    </div>
</template>

<script>
import JsonEditorVue from 'json-editor-vue/dist/json-editor-vue.umd.js'
import 'vanilla-jsoneditor/themes/jse-theme-dark.css'

export default {
    name: 'JsonEditor',
    components: {
        JsonEditorVue
    },
    props: {
        value: {
            default: () => ({})
        },
        mode: {
            type: String,
            default: 'tree'
        },
        stringified: {
            type: Boolean,
            default: true
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
            default: '420px'
        },
        mainMenuBar: {
            type: Boolean,
            default: true
        },
        navigationBar: {
            type: Boolean,
            default: true
        },
        statusBar: {
            type: Boolean,
            default: true
        },
        validateError: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            internalValue: this.normalizeValue(this.value)
        }
    },
    watch: {
        value(newVal) {
            const normalized = this.normalizeValue(newVal)
            if (JSON.stringify(normalized) !== JSON.stringify(this.internalValue)) {
                this.internalValue = normalized
            }
        }
    },
    methods: {
        normalizeValue(val) {
            if (val === null || val === undefined || val === '') {
                return {}
            }
            if (typeof val === 'string') {
                try {
                    return JSON.parse(val)
                } catch (e) {
                    return val
                }
            }
            return val
        },
        handleInput(val) {
            let output = val
            if (this.stringified) {
                if (typeof val === 'object' && val !== null) {
                    try {
                        output = JSON.stringify(val)
                    } catch (e) {
                        output = val
                    }
                }
            }
            this.$emit('input', output)
            this.$emit('change', output)
        }
    }
}
</script>

<style scoped>
.json-editor-wrapper {
    width: 100%;
    border: 1px solid #3c3c3c;
    border-radius: 6px;
    overflow: hidden;
    background-color: #1e1e1e;
    position: relative;
}

.json-editor-wrapper >>> .json-editor-inner,
.json-editor-wrapper >>> .json-editor-vue,
.json-editor-wrapper >>> .jse-main {
    height: 100% !important;
    min-height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
}

.json-editor-wrapper >>> .jse-contents {
    flex: 1 1 auto !important;
    height: auto !important;
    min-height: 0 !important;
    overflow-y: auto !important;
    overflow-x: auto !important;
}

.json-editor-wrapper >>> .jse-tree {
    overflow-y: auto !important;
    height: 100% !important;
}

.json-editor-wrapper >>> .cm-editor,
.json-editor-wrapper >>> .cm-scroller {
    height: 100% !important;
    overflow: auto !important;
}

.json-editor-wrapper.box-border-color {
    border-color: #dc3545;
}
</style>
